export * from './delete-abschnitt.service';
export * from './delete-abschnitt.service.module';